/*************************************************/
/* ANIMATIONS                                    */
/*************************************************/
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animations() {

    ScrollTrigger.defaults({
        toggleActions: "restart pause resume pause"
    });

// Function to create the timeline for a given group of elements
function createBackgroundAnimation(containerClass, backgroundClass) {
    return gsap.timeline({
        scrollTrigger: {
            trigger: containerClass, // Dynamically use the container class
            scrub: 1
        }
    })
    .addLabel('spin')
    .to(backgroundClass, { rotation: 55 }) // Target the background class
    .addLabel('end');
}

// Create animations for both sliders
let textSliderTimeline = createBackgroundAnimation('.text-slider', '.text-slider__background-image');
// let quoteSliderTimeline = createBackgroundAnimation('.quote-slider', '.quote-slider__background-image');

}